module.exports = __webpack_public_path__ + "img/lesson2.91cebcf1.png";